import {
  MAPPING_REVIEW_STATUS_OPTIONS,
  type MappingReviewStatus,
} from "@/lib/mappingReview/constants";

export const colorStyles: Record<string, string> = {
  emerald:
    "bg-emerald-100 dark:bg-emerald-900/50 text-emerald-700 dark:text-emerald-400 border-emerald-200 dark:border-emerald-800",
  amber:
    "bg-amber-100 dark:bg-amber-900/50 text-amber-700 dark:text-amber-400 border-amber-200 dark:border-amber-800",
  rose: "bg-rose-100 dark:bg-rose-900/50 text-rose-700 dark:text-rose-400 border-rose-200 dark:border-rose-800",
};

type StatusColor = keyof typeof colorStyles;

const statusColors: Record<MappingReviewStatus, StatusColor> = {
  mapped: "emerald",
  pending: "amber",
  needs_review: "rose",
  failed: "rose",
};

export const statusConfig: Record<
  MappingReviewStatus,
  { label: string; color: StatusColor }
> = MAPPING_REVIEW_STATUS_OPTIONS.reduce(
  (acc, option) => ({
    ...acc,
    [option.value]: {
      label: option.value === "pending" ? "Pending Mapping" : option.label,
      color: statusColors[option.value],
    },
  }),
  {} as Record<MappingReviewStatus, { label: string; color: StatusColor }>,
);

export const badgeBase =
  "inline-flex items-center gap-1 px-2 py-0.5 text-[10px] font-semibold rounded-full border";
